module.exports = __webpack_public_path__ + "img/xls.8d005f48.svg";